import { FlexboardApiClient } from "@/natsstubs/flexboard/client";
import { keysToSnake } from "@/natsstubs/wire/transform";

import type { NatsRpcBackend } from "../NatsRpcBackend";

export function registerFlexboardAdapters(nats: NatsRpcBackend): void {
  const client = new FlexboardApiClient(nats.caller);
  const id = (args: unknown[]): string => String(args[0]);

  nats.register("session", "core", {
    get_flexboard_types: async (args: unknown[]) =>
      (await client.getTypes({ sessionId: id(args) })).types,

    create_flexboard_type: async (args: unknown[]) =>
      (
        await client.createType({
          sessionId: id(args),
          name: args[1] as string,
          background: args[2] as string,
        })
      ).id,

    update_flexboard_type: async (args: unknown[]) =>
      client.updateType(
        { flexboardTypeId: id(args), name: args[1] as string, background: args[2] as string },
        id(args),
      ),

    delete_flexboard_type: async (args: unknown[]) =>
      client.deleteType({ flexboardTypeId: id(args) }, id(args)),

    get_flexboard_backgrounds: async () => keysToSnake((await client.getBackgrounds()).backgrounds),
  });
}
